import McpProjectConfigs from './McpProjectConfigs.vue';

export default McpProjectConfigs;



// WEBPACK FOOTER //
// ./resources/assets/js/components/McpProjectConfigs/index.js